<template>
  <div class="" style="">
    <special-header @clickTop="clickTop" pagetype="index"></special-header>

    <!-- 图片-板块 -->
    <div class="index-imgs">
      <!-- 标题 -->
      <div class="title f-28 pt-30 pb-10 t-c c-33">精选图片</div>
      <div class="f-14 c-99 t-c mt-10">FEATURED PHOTOS</div>
      <!-- 图片导航菜单 -->
      <div class="flex-c flex cate ptb-25">
        <div class="mr-10 t-c f-14 filter-btn" :class="index == pic_navindex ? 'active' : ''"
          v-for="(item, index) in pic_cates" :key="index" @click="chooseImg(index)">
          {{ item.SYS_TOPIC }}
        </div>
      </div>
      <!-- <div class="filter-btn " :class="cats==item.id?'active':''" v-for="item in video_cate" :key="item.id" @click="bindlinkTo('/video_list?cats=' + item.id,item.title)">{{item.title}}</div> -->
      <div class="list flex flex-x-s flex-wrap">
        <div v-for="(item, index) in index_imgs"
          @click="toImgdetail('/specialimg_detail', item.docId, item.docLibId, 'hfwl')" :key="index"
          class="index-img-detail mt-20 relative" @mouseenter="imgEnter(index, true)"
          @mouseleave="imgEnter(index, false)">
          <img :src="item.middlePath" />
          <div class="text f-16 c-33 t-c onelist plr-30">
            {{ (item.sysDoclibid == 837 ? '【组图】 ' : '') + item.docName }}
          </div>

          <!-- 遮到层说明 -->
          <div class="index-img-zd absolute c-ff f-14 p-30 flex-c" :class="item.isShow ? 'isshow' : ''">
            <div v-if="item.isShow" class="list3">{{ item.docName }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 专题-板块 -->
    <div class="index-zt-box">
      <div class="index-zt">
        <!-- 标题 -->
        <div class="title f-28 pt-30 pb-10 t-c c-33">推荐专题</div>
        <div class="f-14 c-99 t-c mt-10">RECOMMENDED TOPICS</div>
        <div class="index-zt-list flex" v-if="zt_arr.length">
          <!-- <div class="mr-20 relative" @click="enterSpecial(item.DOC_SOURCEURL)" v-for="(item, index) in zt_arr"
            v-if="index == 0" @mouseenter="ztEnter(index, true)" @mouseleave="ztEnter(index, false)">
            <img class="img1" :src="item.pub_picBig" />
            <div class="index-zt-zd flex-c  flex-dir-col absolute plr-30" :class="item.isShow ? 'isShow' : ''">
              <p class="twolist c-ff" v-show="item.isShow">{{ item.XINWENZIXUN_SYS_TOPIC }}</p>
              <p class="twolist c-ff mt-10" v-show="item.isShow">{{ item.XINWENZIXUN_REMARK }}</p>
            </div>
          </div> -->
          <!-- v-if="index > 0" -->
          <div class="flex-box flex  flex-wrap">
            <div class="relative" @click="enterSpecial(item.XINWENZIXUN_DOC_SOURCEURL)" v-for="(item, index) in zt_arr"
              :class="index > 3 ? 'mt-20' : ''" @mouseenter="ztEnter(index, true)" @mouseleave="ztEnter(index, false)">
              <img class="img-more" :src="item.pub_picBig" />
              <div class="index-zt-zd1 flex-dir-col flex-c plr-30 absolute" :class="item.isShow ? 'isShow' : ''">
                <p class="twolist c-ff f-16" v-show="item.isShow">
                  {{ item.XINWENZIXUN_SYS_TOPIC }}
                </p>
                <p class="twolist c-ff mt-10 " v-show="item.isShow">
                  {{ item.XINWENZIXUN_REMARK }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 视频-板块 -->
    <div class="index-sp-box " v-if="video_arr.length">
      <div class="index-sp">
        <!-- 标题 -->
        <div class="title f-28 pt-30 pb-10 t-c c-33">精彩视频</div>
        <div class="f-14 c-99 t-c mt-10">WONDERFUL VIDEOS</div>
        <div class="index-sp-list flex">
          <div class="mr-25 relative img-box1"
            @click="toImgdetail('/specialvideo_detail', item.docId, item.docLibId, 'hfwl')"
            v-for="(item, index) in video_arr" @mouseenter="isShowVideo(index)" @mouseleave="isHideVideo(index)"
            :key="index" v-if="index == 0">
            <img :src="item.middlePath" alt="" class="img1" v-if="item.isShow" />
            <video class="img1" autoplay="autoplay" loop="loop" width="100%" height="100%" :src="item.isShow
              ? ''
              : $baseURL + '/pub/api/media.mp4?s=S' +
              item.suijinum +
              'S&i=' +
              item.docId +
              '_' +
              item.docLibId
              "></video>
          </div>
          <div class="flex-box flex  flex-wrap">
            <div @click="toImgdetail('/specialvideo_detail', item.docId, item.docLibId, 'hfwl')"
              @mouseenter="isShowVideo(index)" @mouseleave="isHideVideo(index)" v-for="(item, index) in video_arr"
              v-if="index > 0 && index < 5" :class="index > 2 ? 'mt-15' : ''" class="relative img-box2 ">
              <img :src="item.middlePath" class="img-more" alt="" v-if="item.isShow" />
              <video class="img-more" autoplay="autoplay" loop="loop" width="100%" height="100%" :src="item.isShow
                ? ''
                : $baseURL + '/pub/api/media.mp4?s=S' +
                item.suijinum +
                'S&i=' +
                item.docId +
                '_' +
                item.docLibId
                "></video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-view typeName="hfwl"></footer-view>
  </div>
</template>

<script>
import specialHeader from './specialHeader.vue';
import footerView from './footer.vue';
export default {
  data() {
    return {
      pic_cates: [], // 首页推荐-图片分类
      index_imgs: [], // 图片列表
      pic_navindex: 0,
      zt_arr: [],
      video_arr: [],
      index_news: [], // 首页推荐资讯列表
      seoKeywords: '',
      seoDesc: '',
      code: 0,
      loginType: 0,
      nav_list: [],
    };
  },

  components: {
    specialHeader,
    footerView
  },

  created() {
    let _this = this;
    // this.bindNav()
    this.$Spin.show();
    this.bindCaterec(); // 获取图片首页推荐分类
    this.getindexInfo(); // 获取首页资源分类
    this.bindNews(); // 获取首页资讯
    this.getztList();
    this.$Spin.hide();
    // this.bindNavlist()
    // console.log(_this.$route.query)
  },

  mounted() { },

  methods: {
    // 获取图片分类
    async bindNavlist() {
      let _this = this
      const res = await _this.get('/spc/cms/col/getAllColBySiteId.do', { siteId: 101, chId: 35 })
      if (res.success) {
        console.log(res);
        let arr = res.data.filter(x => x.pId == 155)

      } else {

      }
    },
    clickTop(index) {
      this.chooseImg(index)
    },
    // 推荐分类的不同专题
    async bindCaterec() {
      let _this = this;
      let data = {
        conditions: JSON.stringify([{ pub_col_id: 155 }, { pub_sale_status: 1 }]),
        orderBy: 'pub_a_order asc pub_lastmodified desc id asc',
        pageNo: 1,
        pageSize: 15,
        searchText: ''
      };
      const res = await _this.post('/spc/cms/publish/list.do', data);
      // console.log("图片分类",res);
      if (res.success) {
        res.result.forEach(x => {
          let index = x.DOC_SOURCEURL.indexOf('?');
          x.params = x.DOC_SOURCEURL.substr(index + 1);
        });
        _this.pic_cates = res.result;
        console.log("图片分类", _this.pic_cates);
        _this.bindimgs(res.result[0].params);
      } else {
        _this.$Message.error(res.description);
      }

    },

    // 获取SEO参数
    async getseo() {
      let _this = this;
      const res = await _this.get_res('/subAndLibraryAndSiteInfo?sld=AHSCXB');
      // seoDesc: "安徽"
      // seoKeywords: "安徽图片
      _this.seoDesc = res.data.subInfo.seoDesc;
      _this.seoKeywords = res.data.subInfo.seoKeywords;
    },

    // 跳转专题详情
    enterSpecial(src) {
      let index = src.lastIndexOf('=');
      let topicId = src.substr(index + 1);
      let url = src.substr(0, index);
      console.log(url);
      if (url != this.$baseURL + '/special_hfwldetail?id') {
        return window.open(src);
      }
      // this.$router.push({path:'/special_detail',query: {topicId}})

      let link = this.$router.resolve({
        path: '/special_hfwldetail',
        query: { topicId, type: 'hfwl' }
      });
      window.open(link.href, '_blank'); //打开新窗口
    },
    // 根据分类获取对应的图片
    async bindimgs(params) {
      // console.log(11111);
      let _this = this;
      _this.$Spin.show();
      const res = await _this.get_res('/topic/res/page?' + params, { sld: 'AHSCXB', size: 12 });
      console.log('获取图片', res);
      if (res.content.length) {
        _this.index_imgs = res.content;
      }
      _this.$Spin.hide();
    },
    // 选择不同的分类获取对应的图片
    chooseImg(index) {
      let _this = this;
      _this.pic_navindex = index;
      _this.bindimgs(_this.pic_cates[index].params);
    },

    // 获取不同的资源分类
    async getindexInfo(params) {
      let _this = this;
      const res = await _this.get_res('/topic/list', { sld: 'AHSCXB', alias: 'video_hfswlj' });

      if (res.length) {
        let video = res.filter(x => x.id == '44');
        _this.getindexVideo(video[0].id); // 获取视频
        console.log('原始视频', video);
      }
    },

    // 获取首页专题列表
    async getztList() {
      let _this = this;
      let data = {
        conditions: JSON.stringify([{ pub_col_id: 154 }, { pub_sale_status: 1 }]),
        orderBy: 'pub_a_order asc pub_lastmodified desc id asc',
        pageNo: 1,
        pageSize: 15,
        searchText: ''
      };
      const res = await _this.post('/spc/cms/publish/list.do', data);
      // console.log(res)
      if (res.success) {
        res.result.forEach(x => {
          x.date = _this.util.formatDate(x.XINWENZIXUN_PUB_DATE);
          x.year = x.date.substr(0, 4);
          x.mon = x.date.substr(5, 2);
          x.day = x.date.substr(8, 2);
        });
        _this.zt_arr = res.result;
        console.log("专题数据", _this.zt_arr);
      } else {
        _this.$Message.error(res.description);
      }
    },

    // 获取视频 注意先取视频栏目下面的资源
    async getindexVideo(topicId) {
      // console.log(11212121);
      let _this = this;
      const res = await _this.get_res('/topic/res/page', { sld: 'AHSCXB', topicId: 72 });
      console.log("视频数据", res);
      res.content.forEach(async x => {
        x.isShow = true;
        const res_1 = await _this.get_video(x.docId);
        x.attId = res_1[0];
        x.suijinum = _this.randomNum(0, 1000);
      });
      _this.video_arr = res.content;
    },

    randomNum(minNum, maxNum) {
      switch (arguments.length) {
        case 1:
          return parseInt(Math.random() * minNum + 1, 10);
          break;
        case 2:
          return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
          break;
        default:
          return 0;
          break;
      }
    },

    // 控制视频是显示封面 还是 视频
    isShowVideo(index) {
      let _this = this;
      let obj = _this.video_arr[index];
      obj.isShow = false;
      _this.video_arr.splice(index, 1, obj);
    },
    // 控制视频是显示封面 还是 视频
    isHideVideo(index) {
      let _this = this;
      let obj = _this.video_arr[index];
      obj.isShow = true;
      _this.video_arr.splice(index, 1, obj);
    },

    // 获取首页资讯
    async bindNews() {
      let _this = this;
      let data = {
        conditions: JSON.stringify([{ pub_col_id: 4 }, { pub_sale_status: 1 }]),
        orderBy: 'pub_a_order asc pub_lastmodified desc id asc',
        pageNo: 1,
        pageSize: 15,
        searchText: ''
      };
      const res = await _this.post('/spc/cms/publish/list.do', data);
      // console.log(res)
      if (res.success) {
        res.result.forEach(x => {
          x.date = _this.util.formatDate(x.XINWENZIXUN_PUB_DATE);
          x.year = x.date.substr(0, 4);
          x.mon = x.date.substr(5, 2);
          x.day = x.date.substr(8, 2);
        });
        _this.index_news = res.result;
      } else {
        _this.$Message.error(res.description);
      }
    },

    // 下面是操作图片的遮到显示隐藏
    imgEnter(index, sate) {
      let _this = this;
      let obj = _this.index_imgs[index];
      obj.isShow = sate;
      _this.index_imgs.splice(index, 1, obj);
    },

    ztEnter(index, sate) {
      let _this = this;
      let obj = _this.zt_arr[index];
      obj.isShow = sate;
      _this.zt_arr.splice(index, 1, obj);
    },

    // 跳转到图片详情
    toImgdetail(path, id, tid, type) {
      // this.$router.push({path, query: {id,tid}})
      let link = this.$router.resolve({
        path,
        query: { id, tid, type }
      });
      window.open(link.href, '_blank'); //打开新窗口
    },

    // 跳转
    bindlinkTo(id) {
      // this.$router.push({path:'/news_detail',query: {id}})
      let link = this.$router.resolve({
        path: '/news_detail',
        query: { id }
      });
      window.open(link.href, '_blank'); //打开新窗口
    },

    // 跳转到新闻列表
    skipageNews() {
      // this.$router.push({path: '/news_list'})
      let link = this.$router.resolve({
        path: '/news_list'
      });
      window.open(link.href, '_blank'); //打开新窗口
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.index-imgs {
  width: 1300px;
  margin: 0 auto;
  padding-bottom: 70px;
}

.index-imgs .title {
  width: 142px;
  border-bottom: 3px solid #f44336;
  margin: 0 auto;
}

.index-imgs {
  .cate {
    >div {
      width: 100px;
      height: 32px;
      border: 1px solid #eee;
      line-height: 32px;
      cursor: pointer;
    }
  }

  .index-img-detail {
    cursor: pointer;
    box-shadow: 0px 2px 18px 0px rgba(4, 0, 0, 0.11);
    width: 310px;
    margin-right: 20px;

    img {
      height: 232px;
      width: 310px;
    }

    .text {
      height: 40px;
      line-height: 40px;
    }
  }

  .index-img-detail:nth-child(4n) {
    margin-right: 0;
  }
}

.index-zt-box {
  background-color: #efefef;

  .index-zt {
    width: 1300px;
    margin: 0 auto;

    .title {
      width: 142px;
      border-bottom: 3px solid #f44336;
      margin: 0 auto;
    }
  }

  .index-zt-list {
    cursor: pointer;
    padding: 50px 0 70px 0;

    .flex-box {
      height: 520px;
    }

    .img1 {
      width: 320px;
      height: 520px;
    }

    .img-more {
      width: 310px;
      height: 250px;
    }

    .index-zt-zd {
      top: 0;
      width: 320px;
      height: 520px;
      background: rgba(0, 0, 0, 0);
      transition: all 0.3s;
    }

    .index-zt-zd1 {
      top: 0;
      width: 310px;
      height: 250px;
      background: rgba(0, 0, 0, 0);
      transition: all 0.3s;
    }

    .index-zt-zd.isShow,
    .index-zt-zd1.isShow {
      background: rgba(0, 0, 0, 0.4);
    }
  }
}

.index-sp-box {
  .index-sp {
    width: 1320px;
    margin: 0 auto;

    .title {
      width: 142px;
      border-bottom: 3px solid #f44336;
      margin: 0 auto;
    }
  }

  .index-sp-list {
    padding: 30px 0 40px 0;
    cursor: pointer;

    .flex-box {
      height: 375px;
    }

    .img-box1 {
      width: 655px;
      height: 375px;
      // box-shadow: 0 0 4px 0 rgba(0,0,0,0.20);
      border-radius: 8px;
      overflow: hidden;
    }

    .img-box2 {
      width: 310px;
      height: 180px;
      // box-shadow: 0 0 4px 0 rgba(0,0,0,0.20);
      border-radius: 8px;
      overflow: hidden;
    }

    img.img1 {
      position: absolute;
      z-index: 22;
      width: 100%;
      height: 100%;
    }

    img.img-more {
      position: absolute;
      z-index: 22;
      width: 100%;
      height: 100%;
    }
  }
}

.index-news-box {
  .index-news {
    width: 1200px;
    margin: 0 auto;

    .title {
      width: 142px;
      border-bottom: 3px solid #f44336;
      margin: 0 auto;
    }
  }

  .index-new-list {
    cursor: pointer;
    padding: 30px 0 40px 0;

    // .flex-box {height: 375px;}
    .detail-max {
      width: 535px;

      img {
        width: 100%;
        height: 140px;
      }

      .date-box {
        width: 70px;
        height: 80px;
        top: 0;
        left: 0;
        background-color: #f44336;
      }

      .new-t {
        color: #e31837;
      }

      .new-more {
        width: 160px;
        height: 36px;
        line-height: 36px;
        background-color: #fe9d00;
        cursor: pointer;
      }
    }

    .detail-min {
      height: 110px;
      border-bottom: 1px solid #ededed;

      .bold {
        color: #f44336;
      }
    }
  }
}

.index-adv-box {
  background-color: #fafafa;

  .index-adv {
    width: 1200px;
    margin: 0 auto;

    .title {
      width: 142px;
      border-bottom: 3px solid #f44336;
      margin: 0 auto;
    }
  }

  .index-new-list {
    padding: 60px 0 90px 0;

    >div {
      width: 270px;
      height: 260px;
      border-radius: 6px;
      border: 1px solid #f3f3f3;

      .icon {
        width: 70px;
        height: 70px;
      }

      .line {
        width: 20px;
        height: 8px;
        border-radius: 4px;
        background-color: #de0f55;
      }
    }
  }
}

.filter-btn {
  padding: 0 10px;
  height: 26px;
  line-height: 26px;
  border-radius: 16px;
  margin-right: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.filter-btn:hover,
.filter-btn.active {
  color: #fff;
  background-color: #00a1d6;
  border: 1px solid #00a1d6;
}

// 优化样式
.index-img-zd {
  top: 0;
  width: 100%;
  height: 232px;
  background: rgba(0, 0, 0, 0);
  transition: all 0.4s;
}

.index-img-zd.isshow {
  background: rgba(0, 0, 0, 0.4);
}
</style>
